/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  // 独自の共通処理
  var Seren = {
    smoothScroll: function(event) {
      var speed = 500;
      var match = $(event.currentTarget).attr('href').match(/#.*$/);
      if(match[0] === null) {
        return true;
      }

      var href = $(event.currentTarget).attr('href');
      var target = $(href === '#' || href === '' ? 'html' : match[0]);
      var position = 0;

      if(!target.size()) {
        return true;
      }

      if (href !== 'html') {
        position = target.offset().top;
      }

      $('html, body').animate({scrollTop: position}, speed, 'swing');

      return false;
    }
  };

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // 全てのページ
    'common': {
      init: function() {
        // サブメニューの表示・非表示
        $('.menu-pc .dropdown').mouseenter(function(event) {
          var offset = (5120 / 2 - ($(this).offset().left + $(this).innerWidth() / 2)) * -1;
          $('> .submenu', this).css('background-position', offset + 'px top');
          $('> .submenu', this).fadeIn('normal');
          $('.navbar').addClass('dark');
        }).mouseleave(function(event) {
          $('> .submenu', this).hide();
          $('.navbar').removeClass('dark');
        });

        // サブメニューのロールオーバー画像
        $('.submenu a').mouseover(function(event) {
          $($(this).attr('data-target')).attr('src', '/wp-content/themes/yk2017en/dist/images/submenu/' + $(this).attr('data-img'));
        });

        // SP用メニューの表示・非表示
        $('.btn-hamburger').click(function() {
          $('body').toggleClass('no-scroll');
          $(this).toggleClass('open');
          $('.menu-sp').toggle();
        });

        $('.menu-sp .dropdown').click(function() {
          $(this).toggleClass('open');
          $('> ul', this).slideToggle('fast');
          return false;
        });

        $('.menu-sp .dropdown > ul').click(function(event) {
          event.stopPropagation();
        });

        // STORESブロックのカルーセル表示
        if (window.matchMedia('(max-width: 991px)').matches) {
          $('.stores-carousel').slick({
            dots: true
          });
        }

        // ドレス詳細ページのカルーセル表示
        if ($('.dress-carousel').length) {
          $('.dress-carousel').slick({
            dots: true
          });
        }

        // ドレス詳細ページのサムネイルクリック
        $('.block-dress-single .thumbnail img').click(function() {
          $('.block-dress-single .thumbnail img').removeClass('active');

          var src = $(this).attr('src');
          $('.block-dress-single img.main-image').attr('src', src);
          $(this).addClass('active');
        });

        // スムーススクロール
        $('a.scroll').click(Seren.smoothScroll);

        // WindowがリサイズされたらPC⇔SP表示を切替え
        $(window).resize(function() {
          if (window.matchMedia('(min-width: 992px)').matches) { // PC
            // SP用メニューが表示されていたら非表示にする
            if ($('.menu-sp').is(':visible')) {
              $('.menu-sp').hide();
              $('.menu-sp .dropdown > ul').hide();
              $('.btn-hamburger').removeClass('open');
              $('.menu-sp .dropdown').removeClass('open');
              $('body').removeClass('no-scroll');
            }

            // STORESブロックのカルーセル解除
            if ($('.stores-carousel').hasClass('slick-initialized')) {
              $('.stores-carousel').slick('unslick');
            }
          } else { // SP
            // STORESブロックのカルーセル表示
            if (!$('.stores-carousel').hasClass('slick-initialized')) {
              $('.stores-carousel').slick({
                dots: true
              });
            }
          }
        });
      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    'home': {
      init: function() {
        $('.carousel').delay(100).queue(function(){
            // メインカルーセル
            $(this).show();
            $(this).slick({
              dots: true,
              fade: true,
              autoplay: true,
              autoplaySpeed: 6000,
              speed: 1000,
              pauseOnHover: false,
              pauseOnDotsHover: false,
              adaptiveHeight: true,
              lazyLoad: 'progressive'
            });
            $('.main-visual-lowres').hide();
        });

        // // メインカルーセル
        // var slick = $('.carousel').slick({
        //   dots: true,
        //   fade: true,
        //   autoplay: true,
        //   autoplaySpeed: 6000,
        //   speed: 1000,
        //   pauseOnHover: false,
        //   pauseOnDotsHover: false,
        //   adaptiveHeight: true,
        //   lazyLoad: 'progressive'
        // });

        // スクロール位置によるメニューの配色切替え
        $(window).on('scroll', function() {
          var threthold = $('.carousel img').height() - $('.navbar').height();

          if ($(this).scrollTop() > threthold) {
            $('nav').addClass('navbar-default').removeClass('navbar-inverse');
            $('.navbar-nav').removeClass('shadow');
            $('.navbar-header .navbar-brand img').attr('src', '/wp-content/themes/yk2017/dist/images/logo.svg');
          } else {
            $('nav').removeClass('navbar-default').addClass('navbar-inverse');
            $('.navbar-nav').addClass('shadow');
            $('.navbar-header .navbar-brand img').attr('src', '/wp-content/themes/yk2017/dist/images/logo_inverse.svg');
          }
        });
      }
    },
    'legacy': {
      init: function() {
        // クリックされたブロックを表示し、他は隠す
        $('.legacy-selector a').click(function() {
          var target = $(this);
          $('[class*="block-legacy-"]').each(function(index, element) {
            if ($(element).attr('class') !== target.attr('data-target')) {
              $(element).hide();
              $('.legacy-selector .active').removeClass('active');
            } else {
              $(element).show();
            }
          });
          target.addClass('active');
          return false;
        });

        // WindowがリサイズされたらPC⇔SP表示を切替え
        $(window).resize(function() {
          if (window.matchMedia('(min-width: 992px)').matches) { // PC
            $('[class*="block-legacy-"]').show();
          } else { // SP
            var active = $('.legacy-selector .active');
            $('[class*="block-legacy-"]').each(function(index, element) {
              if ($(element).attr('class') !== active.attr('data-target')) {
                $(element).hide();
              }
            });
          }
        });
      }
    },
    'stores_tokyo': {
      init: function() {
        // フロアクリック時の動作
        $('.floor-list a').click(function(event) {
          if (window.matchMedia('(min-width: 992px)').matches) { // PC
            // スムーススクロール
            Seren.smoothScroll(event);
          } else { // SP
            // クリックされたブロックを表示し、他は隠す
            var target = $(this);
            $('.floor').each(function(index, element) {
              if (!$(element).hasClass(target.attr('data-target'))) {
                $(element).hide();
                $('.floor-list .active').removeClass('active');
              } else {
                $(element).show();
              }
            });
            target.addClass('active');
            return false;
          }
        });

        // WindowがリサイズされたらPC⇔SP表示を切替え
        $(window).resize(function() {
          if (window.matchMedia('(min-width: 992px)').matches) { // PC
            $('.floor').show();
          } else { // SP
            var active = $('.floor-list .active');
            $('.floor').each(function(index, element) {
              if (!$(element).hasClass(active.attr('data-target'))) {
                $(element).hide();
              }
            });
          }
        });
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
